import styled, { keyframes } from "styled-components";
import { theme } from "@theme";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const slideIn = keyframes`
  from { transform: translateY(-50px); }
  to { transform: translateY(0); }
`;

const slideOut = keyframes`
  from { transform: translateY(0); }
  to { transform: translateY(-50px); }
`;

export const Overlay = styled.div<{ isOpen: boolean }>`
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: ${({ isOpen }) => (isOpen ? fadeIn : fadeOut)} 0.3s forwards;
  
  @media screen and (max-width: ${theme.breakpoints.sm}) {
    z-index: 10000;
  }
`;

export const ModalContainer = styled.div<{ isOpen: boolean, fitContent?: boolean }>`
  background: rgba(255, 251, 248, 1);
  border-radius: 8px;
  position: relative; 
  animation: ${({ isOpen }) => (isOpen ? slideIn : slideOut)} 0.3s forwards;

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    width: ${({ fitContent }) => (fitContent ? "calc(100% - 32px)" : "100%")};
    height: ${({ fitContent }) => (fitContent ? "auto" : "100%")};
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: #aaa;
  transition: color 0.2s;

  &:hover {
    color: #000;
  }
`;
